import AiIcon from "@redotech/redo-icons/stars-01.svg";
import { ConciergeProductFormSettings } from "@redotech/redo-model/concierge-product-form/concierge-product-form";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { ConciergeProductFormProps } from "./concierge-product-form";
import * as styles from "./question-chip-area.module.css";

interface QuestionChipsProps {
  onQuestionSelect: (question: string) => void;
  settings: ConciergeProductFormSettings;
  useConciergeQuestions: ConciergeProductFormProps["useConciergeQuestions"];
}

export const QuestionChipArea = memo(function QuestionChips({
  settings,
  onQuestionSelect,
  useConciergeQuestions,
}: QuestionChipsProps) {
  const questionsLoad = useConciergeQuestions({
    currentUrl: new URL(location.href),
  });

  const questions = questionsLoad.value?.questions;

  return (
    <StaticQuestions
      onQuestionSelect={onQuestionSelect}
      questions={questions}
    />
  );
});

const StaticQuestions = memo(function StaticQuestions({
  questions,
  onQuestionSelect,
}: {
  questions: string[] | undefined;
  onQuestionSelect: (question: string) => void;
}) {
  if (!questions) {
    return null;
  }

  const questionsToShow = [...questions];

  return questionsToShow.length > 0 ? (
    <Flex dir="row" gap="sm" wrap="wrap">
      {questionsToShow.map((question, index) => {
        return (
          <Flex
            align="center"
            as="button"
            borderColor="secondary"
            borderStyle="solid"
            borderWidth="1px"
            className={styles.badgeButton}
            dir="row"
            gap="xs"
            key={index}
            onClick={() => onQuestionSelect(question)}
            px="sm"
            py="xxs"
            radius="xs"
          >
            <AiIcon className={styles.aiIcon} />
            <Text fontSize="xs">{question}</Text>
          </Flex>
        );
      })}
    </Flex>
  ) : null;
});
